import { Download, Visibility } from "@mui/icons-material";
import { CircularProgress, IconButton, TableCell, Tooltip } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import { GetBinary } from "../../../../services/fhir/patientsummary/Binary/GetBinary";

/**
 * Ações de documentos já assinados.
 * Suporta PDF da sessão (base64/signedBase64) ou Binary do FHIR (binaryUrl).
 */
export function SignedDocsActions({ row, setSignedDocView }: any) {
  const [loading, setLoading] = useState(false);

  function downloadBase64File(base64: string, type: string) {
    const linkSource = `data:application/pdf;base64,${base64}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = type || "documento";
    downloadLink.click();
  }

  async function resolvePdfBase64(): Promise<string | undefined> {
    if (row?.base64) return row.base64;

    if (row?.binaryUrl) {
      setLoading(true);
      try {
        const response = await GetBinary({ urlBinary: row.binaryUrl });
        return response?.data;
      } catch (err) {
        console.error("SignedDocsActions GetBinary:", err);
        toast.warn("Não foi possível carregar o documento assinado.");
        return undefined;
      } finally {
        setLoading(false);
      }
    }

    return undefined;
  }

  async function handleShowPDF() {
    const pdf = await resolvePdfBase64();
    if (pdf) setSignedDocView(pdf);
  }

  async function handleDownload() {
    const pdf = await resolvePdfBase64();
    if (pdf) downloadBase64File(pdf, row?.type);
  }

  return (
    <>
      <TableCell align="center" sx={{ minWidth: "145px" }}>
        {loading ? (
          <CircularProgress size={20} />
        ) : (
          <>
            <Tooltip title="Visualizar">
              <IconButton onClick={() => handleShowPDF()}>
                <Visibility fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Baixar">
              <IconButton onClick={() => handleDownload()}>
                <Download fontSize="small" />
              </IconButton>
            </Tooltip>
          </>
        )}
      </TableCell>
    </>
  );
}
